import React from "react";
import Icon from "@ant-design/icons";

const StarIconSvg = ({ width = 14, height = 14 }) => {
  const maxDimension = Math.max(width, height);
  const scaleFactor = maxDimension / 14; // Calculate scale factor

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#FEC84B"
        d="M6.193 1.118a.9.9 0 011.614 0L8.914 3.36a2 2 0 001.506 1.094l2.474.36a.9.9 0 01.499 1.535l-1.79 1.745a2 2 0 00-.576 1.77l.423 2.465a.9.9 0 01-1.306.949l-2.213-1.164a2 2 0 00-1.862 0l-2.213 1.164a.9.9 0 01-1.306-.949l.423-2.464a2 2 0 00-.575-1.77L.608 6.348a.9.9 0 01.498-1.535l2.475-.36A2 2 0 005.086 3.36l1.107-2.242z"
      ></path>
    </svg>
  );
};

const StarIcon = ({ width = 14, height = 14, ...props }) => {
  return (
    <Icon
      component={() => <StarIconSvg width={width} height={height} />}
      {...props}
    />
  );
};

export default StarIcon;
